import { ViewIds } from '@ardoq/api-types';
import type { OnViewSettingsUpdate } from '@ardoq/data-model';
import { DropdownOptionType } from '@ardoq/dropdown-menu';
import type { SetNumeric } from '@ardoq/graph';
import { IconName } from '@ardoq/icons';
import { SettingsType } from '@ardoq/view-settings';
import { createDropdownSliderOptionManager } from '../settingsHelper';
import { type I18nLocale, t } from '@ardoq/i18n';

const getSliderOption = (
  viewId: ViewIds,
  onViewSettingsUpdate: OnViewSettingsUpdate
) => createDropdownSliderOptionManager(viewId, new Map(), onViewSettingsUpdate);

type NodeDistanceSliderArgs = {
  currentValue: number;
  onBeforeUpdate: SetNumeric;
  viewId: ViewIds;
  onViewSettingsUpdate: OnViewSettingsUpdate;
  i18nLocale: I18nLocale;
};
export const nodeDistanceSlider = ({
  currentValue,
  onBeforeUpdate,
  viewId,
  onViewSettingsUpdate,
  i18nLocale,
}: NodeDistanceSliderArgs) => {
  const nodeDistanceLabel = t(
    i18nLocale,
    'settingsBar:nodeDistance',
    'Node distance'
  );
  const sliderOption = getSliderOption(
    viewId,
    onViewSettingsUpdate
  )({
    name: 'nodeDistance',
    label: nodeDistanceLabel,
    value: currentValue,
    min: 30,
    max: 400,
    step: 10,
    type: DropdownOptionType.SLIDER,
  });

  const sliderOptionWithCallback = {
    ...sliderOption,
    onValueChange: (value: number) => {
      sliderOptionWithCallback.value = value;
      onBeforeUpdate(value);
      return sliderOption.onValueChange?.(value);
    },
  };
  return {
    id: 'slider-gravity',
    label: nodeDistanceLabel,
    iconName: IconName.NODE_DISTANCE,
    type: SettingsType.DROPDOWN,
    isKeepOpen: true,
    options: [sliderOptionWithCallback],
  };
};
